import { FC } from 'react';
import { FInter, MagicBox } from '@brg/ui';
import { ReactComponent as WorldSvg } from '../assets/earth.svg';
import { useTheme } from 'styled-components';
import { DisplayType } from '../../../constants/displayType';
import { useTranslation } from 'react-i18next';
import { AppTester } from "../../../../supporting";

export interface ProjectSearchBarProps {
    display: DisplayType;
    onDisplayChange?: () => void;
    hideRightBar?: boolean;
}
export const ProjectSearchBartDisplay: FC<ProjectSearchBarProps> = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    if (!AppTester.isGeograffee()) {
        return null;
    }

    return (
        <MagicBox
            align={'center'}
            color={theme.exploreView.mapGridToggle.color}
            hoverColor={theme.exploreView.mapGridToggle.colorHover}
            gx={8}
            onClick={props.onDisplayChange}
            pointer={true}
            offsetRight={props.hideRightBar ? 0 : 20}
        >
            <FInter.SmallTextDiv>
                <div>{t('exploreView.toggle.' + props.display)}</div>
            </FInter.SmallTextDiv>
            <WorldSvg />
        </MagicBox>
    );
};
import { FC } from 'react';
import { FInter, MagicBox } from '@brg/ui';
import { ReactComponent as WorldSvg } from '../assets/earth.svg';
import { useTheme } from 'styled-components';
import { DisplayType } from '../../../constants/displayType';
import { useTranslation } from 'react-i18next';
import { AppTester } from "../../../../supporting";

export interface ProjectSearchBarProps {
    display: DisplayType;
    onDisplayChange?: () => void;
    hideRightBar?: boolean;
}
export const ProjectSearchBartDisplay: FC<ProjectSearchBarProps> = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    if (!AppTester.isGeograffee()) {
        return null;
    }

    return (
        <MagicBox
            align={'center'}
            color={theme.exploreView.mapGridToggle.color}
            hoverColor={theme.exploreView.mapGridToggle.colorHover}
            gx={8}
            onClick={props.onDisplayChange}
            pointer={true}
            offsetRight={props.hideRightBar ? 0 : 20}
        >
            <FInter.SmallTextDiv>
                <div>{t('exploreView.toggle.' + props.display)}</div>
            </FInter.SmallTextDiv>
            <WorldSvg />
        </MagicBox>
    );
};
